module.exports = __webpack_public_path__ + "assets/images/42826a9c33ed99577f26b7fde29631c9.png";